import { NgFor, NgIf, CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BackendApiService } from '../../../app/services/backend-api.service';
import { MatIcon } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import moment from 'moment-timezone';
import { BaseUrlConstantsService } from '../../../app/services/base-url-constants.service';

@Component({
  selector: 'app-oven-measurements-records',
  standalone: true,
  imports: [NgFor, NgIf, CommonModule, MatIcon, MatButtonModule],
  templateUrl: './oven-measurements-records.component.html',
  styleUrl: './oven-measurements-records.component.scss'
})
export class OvenMeasurementsRecordsComponent implements OnInit {
  public recordsData: any[] = [];
  public isLoading: boolean = true;
  public errorMessage: string = '';
public baseOvenUrl = BaseUrlConstantsService.OVEN_BASE_URL;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public service: BackendApiService,
    public dialogRef: MatDialogRef<OvenMeasurementsRecordsComponent>
  ) {}

  ngOnInit() {
    this.fetchRecords();
  }
convertUtcToIst(utc: string) {
  return moment.utc(utc).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');
}


  fetchRecords() {
    this.isLoading = true;
    this.errorMessage = '';

    const body = {
      client_id: Number(this.data.client_id),
      job_id: this.data.job_number
    };

    this.service.postData(`${this.baseOvenUrl}/api/v1/oven-assets/jobs/all-measurments`, body)
      .then((res: any) => {
        if (res?.data && Array.isArray(res.data)) {
          this.recordsData = res.data;
        } else if (Array.isArray(res)) {
          this.recordsData = res;
        } else if (res?.data && typeof res.data === 'object') {
          this.recordsData = [res.data];
        } else {
          this.recordsData = [];
          this.errorMessage = 'No data available';
        }
        this.isLoading = false;
      })
      .catch((error: any) => {
        this.errorMessage = 'Failed to fetch records';
        this.recordsData = [];
        this.isLoading = false;
      });
  }

  onCancel() {
    this.dialogRef.close();
  }
}